<template>
    <div>
        <div class="flex_b borderB padB6" v-if="i_id==0">
            <el-upload
                    class="upload-demo"
                    :action="action"
                    :data="data"
                    :http-request="beupload"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :limit="limit"
                    :on-exceed="handleExceed"
                    :file-list="fileList">
                <el-button :class="baseerp+'btn'" size="mini" type="primary">选择文件</el-button>
            </el-upload>
            <div>
                <el-button :class="baseerp+'btn'" size="mini" type="primary" @click="submitUpload">上传</el-button>
            </div>
        </div>
        <el-form v-if="i_id==0" class="padT6" v-loading="loading_upl" :model="formData" ref="formRef" label-width="110px" size="mini" inline>
            <el-form-item  label="发票类型" >
                <el-select style="width: 190px" v-model="formData.vc_fptype" @change="changeData($event,'fplx')"  filterable placeholder="请选择" size="mini" >
                    <el-option
                            v-for="item in fplxData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="开票时间" >
                <el-date-picker
                        style="width: 190px"
                        v-model="formData.dt_fptime"
                        size="mini"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item  label="发票代码" >
                <el-input style="width: 190px" size="mini"  v-model="formData.vc_fpcode">
                </el-input>
            </el-form-item>
            <el-form-item  label="发票号码" >
                <el-input style="width: 190px" size="mini"  v-model="formData.vc_number">
                </el-input>
            </el-form-item>
            <el-form-item  label="全电发票号码" >
                <el-input style="width: 190px" size="mini"  v-model="formData.vc_electronic_number">
                </el-input>
            </el-form-item>
            <el-form-item  label="销售方" >
                <el-select style="width: 190px" @change="changekh" class="marr4" v-model="formData.vc_kpkhname" size="mini" clearable filterable placeholder="请选择客户方">
                    <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="客户方" >
                <el-select style="width: 190px" @change="changegs"  class="marr4" v-model="formData.vc_gsname" size="mini" clearable filterable placeholder="请选择销售方" >
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--<el-form-item  label="发票状态" >{{formData.invoiceStatus}}</el-form-item>-->
            <!--<el-form-item  label="关联蓝字发票号" v-if="formData.invoiceType==2">{{formData.relativeBlueCode}}</el-form-item>-->
            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true"
                    style="width: 100%;margin-right: 9px;margin-left: 9px">
                <el-table-column  label="序号" align="center" type="index" width="55px"></el-table-column>
                <el-table-column  :label="$t('form_product_name')" align="center" prop="vc_fppzname" ></el-table-column>
                <el-table-column  label="规格型号" align="center" prop="vc_fpbzstyle" ></el-table-column>
                <el-table-column  label="计量单位" align="center" prop="vc_fpunit" ></el-table-column>
                <el-table-column  label="数量" align="center" prop="f_fpnum" ></el-table-column>
                <el-table-column  label="无税单价" align="center" prop="f_fpprice" ></el-table-column>
                <el-table-column  label="无税金额" align="center" prop="f_fppay_ws" width="118">
                    <template slot-scope="scope">
                        <el-input-number  @change="wspay(tableData,scope.$index,scope.row)"  :controls="false" :precision="5"  :class="i_isfrom==1&&scope.row.f_fppay_ws!=scope.row.f_fppay_ws?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_fppay_ws" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="税率" align="center" prop="f_sl" ></el-table-column>
                <el-table-column  label="税额" align="center" prop="f_fppay_zzs" width="118">
                    <template slot-scope="scope">
                        <el-input-number  @change="sepay(tableData,scope.$index,scope.row)"  :controls="false" :precision="5"  :class="i_isfrom==1&&scope.row.f_fppay_zzs!=scope.row.f_fppay_zzs?'red changeinput':'changeinput'" size="mini" v-model="scope.row.f_fppay_zzs" ></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
            <template v-if="i_isfrom==0">
                <el-form-item  label="无税金额" >
                    <el-input-number style="width: 190px" @change="wspay_no"  :controls="false" :min="0"  :precision="2"  size="mini" v-model="f_pay_ws_upl" ></el-input-number>
                </el-form-item>
                <el-form-item  label="税额" >
                    <el-input-number style="width: 190px" @change="sepay_no" :controls="false" :min="0"  :precision="2"  size="mini" v-model="f_pay_zzs_upl" ></el-input-number>
                </el-form-item>
                <el-form-item  label="总金额" >
                    <el-input-number style="width: 190px" @change="totalpay_no" :controls="false" :min="0"  :precision="2"  size="mini" v-model="f_pay_upl" ></el-input-number>
                </el-form-item>
            </template>
            <div class="flex_b w100 marT10">
                <div class="flex w50 alc">
                    <span class="marr4 font14">价税合计（大写）</span>
                    <span class="marr4 font14">{{DtotalPrice}}</span>
                </div>
                <div class="w50 txtE">
                    <span class="marr4 font14">{{'（小写）'+totalPrice}}</span>
                </div>
            </div>
            <div style="text-align: center;padding: 6px">
                <el-button @click="saveupl" type="primary"  :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
                <el-button @click="cancel" size="small">取消</el-button>
            </div>
        </el-form>
        <el-form v-else class="padT6" :model="formData" ref="formRef" label-width="110px" size="mini" inline>
            <el-form-item  label="开票时间" >{{formData.invoiceDate}}</el-form-item>
            <el-form-item  label="发票代码" >{{formData.invoiceCode}}</el-form-item>
            <el-form-item  label="发票号码" >{{formData.invoiceNum}}</el-form-item>
            <el-form-item  label="全电发票号码" >{{formData.electronicNumber}}</el-form-item>
            <el-form-item  label="销售方" >{{formData.sellerName}}</el-form-item>
            <el-form-item  label="购买方" >{{formData.buyerName}}</el-form-item>
            <el-form-item  label="发票状态" >{{formData.invoiceStatus}}</el-form-item>
            <el-form-item  label="关联蓝字发票号" v-if="formData.invoiceType==2">{{formData.relativeBlueCode}}</el-form-item>
            <el-table
                    class="mrt10"
                    ref="table"
                    size="mini"
                    :height="tableHeight"
                    border
                    :data="tableData"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-current-row="true"
                    style="width: 100%;margin-right: 9px;margin-left: 9px">
                <el-table-column  label="序号" align="center" type="index" width="45px"></el-table-column>
                <el-table-column  :label="$t('form_product_name')" align="center" prop="productName" ></el-table-column>
                <el-table-column  label="规格型号" align="center" prop="model" ></el-table-column>
                <el-table-column  label="计量单位" align="center" prop="measurementUnit" ></el-table-column>
                <el-table-column  label="数量" align="center" prop="count" ></el-table-column>
                <el-table-column  label="无税单价" align="center" prop="taxlessPrice" ></el-table-column>
                <el-table-column  label="无税金额" align="center" prop="taxlessAmount" ></el-table-column>
                <el-table-column  label="税率" align="center" prop="taxRate" ></el-table-column>
                <el-table-column  label="税额" align="center" prop="taxAmount" ></el-table-column>
            </el-table>
        </el-form>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import {erpplatserver} from "@/utils/baseUrl";
    export default {
        name: "DetailPage",
        components: {},
        props:{
            Data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                f_pay_ws_upl:0,
                f_pay_zzs_upl:0,
                f_pay_upl:0,
                gsList:[],
                //i_gsid:0,
                khList:[],
                //i_khid:0,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()  // - 8.64e7;如果要禁用到当前日期则去掉 - 8.64e7
                    },
                },
                i_isfrom:1,
                invoiceType:1,//1蓝票
                fplxData:[],//发票类型
                i_fptype:null,
                vc_fptype:'',
                totalPrice:0,
                DtotalPrice:'零',
                i_id:0,
                loading_upl:false,
                action:erpplatserver+'/system/uploadInvoice',
                data:{
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                },
                fileList:[],
                files: [],
                limit:1,
                /*pickerOptions: {
                    disabledDate(time) {
                        let curDate=(new Date()),perM;
                        if(curDate.getMonth()>0){
                            perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                        }else{
                            perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                        }
                        let today=(new Date()).getDate();
                        let same=today*24*3600*1000;
                        // let sameMonth=curDate-same;//当月月初
                        let sameMonth=perM;
                        return time.getTime() > Date.now() || time.getTime() < sameMonth;
                        // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                        // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的

                    }
                },*/
                baseerp:'',
                canEdit:false,
                formData:{
                },
                tableData:[],
                tableHeight:0,

            }
        },

        watch: {
            Data: {
                handler() {
                    //console.log(this.Data,'this.Data')
                    if (this.Data.type=='add') {
                        this.i_id=0;
                    }
                    if (this.Data.type=='detail') {
                        this.i_id=this.Data.item.recordId;
                        this.formData=JSON.parse(JSON.stringify(this.Data.item));
                        this.withInvoiceServer();
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.fplx();
            this.getKhlistWithNoRights();
            this.getCompanyList();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            // editForm(){
            //     this.canEdit=true
            // },
            wspay(data,index,row){
                //console.log(row.f_fppay_ws,'row.f_fppay_ws')
                if(!row.f_fppay_ws){
                    row.f_fppay_ws=0
                }
                let sl=0;
                if(row.f_fppay_ws==0||!row.f_fppay_ws){
                    sl=0
                }else{
                    sl=this.preciseDiv(row.f_fppay_zzs, row.f_fppay_ws);
                }
                row.f_sl = parseFloat(sl);
                //console.log(row.f_sl,'row.f_sl')
                this.$set(data,index,row)
            },
            sepay(data,index,row){
                if(!row.f_pay_zzs){
                    row.f_pay_zzs=0
                }
                let sl=0;
                if(row.f_fppay_ws==0||!row.f_fppay_ws){
                    sl=0
                }else{
                    sl=this.preciseDiv(row.f_fppay_zzs, row.f_fppay_ws);
                }
                row.f_sl = parseFloat(sl);
                //console.log(row.f_sl,'row.f_sl')
                this.$set(data,index,row)
            },
            wspay_no(){
                //console.log(this.f_pay_ws_upl,'this.f_pay_ws_upl')
                if(!this.f_pay_ws_upl){
                    this.f_pay_ws_upl=0
                }
                let cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl;
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                this.f_pay_upl = cenzzs;
                this.totalPrice= cenzzs;
                this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
            },
            sepay_no(){
                if(!this.f_pay_zzs_upl){
                    this.f_pay_zzs_upl=0
                }
                //console.log(this.f_pay_zzs_upl,'this.f_pay_zzs_upl')
                let cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl;
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                this.f_pay_upl = cenzzs;
                this.totalPrice= cenzzs;
                this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);

            },
            totalpay_no(){
                //console.log(this.f_pay_ws_upl,'f_pay_ws_upl')
                //console.log(this.f_pay_zzs_upl,'f_pay_zzs_upl')
                //console.log(this.f_pay_upl,'f_pay_upl')
                if(this.f_pay_upl == 0 || !this.f_pay_upl){
                    //this.$message.error("总金额不可小于0！ ");
                    this.f_pay_ws_upl=0;
                    this.f_pay_zzs_upl=0;
                    this.f_pay_upl = 0;
                    this.f_gs_upl = 0;
                    this.totalPrice= 0;
                    this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
                    return ;
                }
                let cenzzs=0;
                if(this.i_flag==1){
                    cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl + this.f_gs_upl
                }else{
                    cenzzs = this.f_pay_ws_upl + this.f_pay_zzs_upl;
                }
                cenzzs = parseFloat(cenzzs);
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                if(this.f_pay_upl<less||this.f_pay_upl>more){
                    this.$nextTick(()=>{
                        this.f_pay_upl = cenzzs;
                        this.totalPrice= cenzzs;
                        this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
                    })
                    this.$message.error("总金额不可超过或少于既定总金额"+cenzzs+"正负1！");
                }

            },
            //除
            preciseDiv(dividend, divisor) {
                if(dividend&&divisor){
                    //console.log(dividend,"////",divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result,'result------')
                    return result ;
                }
            },
            changegs(e){
                //console.log(e,'e')
                this.formData.i_gsid=e
                if(e){
                    this.formData.vc_gsname=this.gsList.find(gs=>e==gs.i_id).vc_name
                }
            },
            changekh(e){
                this.formData.i_kpkhid=e
                if(e){
                    this.formData.vc_kpkhname=this.khList.find(kh=>e==kh.i_id).vc_name
                }
            },
            async getKhlistWithNoRights(){
                let param={
                    i_khtype:'2,3,4,5,6,7,8',
                    currentPage:1,
                    pageSize: 50,
                    vc_search: '',
                };
                let res=await API.getKhlistWithNoRights(param);
                if ( res.code == 1 ){
                    this.gsList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_type:'0,2',
                    i_mid:this.mid,
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.khList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //发票类型
            async fplx(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.fplx(param);
                if (res.code == 1) {
                    this.fplxData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            saveupl(){
                if(this.files.length==0){
                    this.$message.error('请上传附件！');
                    return;
                }
                this.saveToPool();
            },
            async saveToPool(){
                this.loading_upl=true;
                let param={
                    //"i_id": this.i_id,
                    //"i_type": this.i_type, //发票类型，2：采购发票， 3： 运费发票 ，32：港杂发票， 4：开证发票 ， 5： 仓储发票 ， 6：保险发票
                    //'i_khtype':this.i_khtype==4?2:this.i_khtype,
                    'i_fptype':this.formData.i_fptype,
                    'vc_fptype':this.formData.vc_fptype,
                    "vc_fpcode": this.formData.vc_fpcode,//发票编号,
                    "i_kpkhid":this.formData.i_kpkhid,
                    "vc_kpkhname":this.formData.vc_kpkhname,
                    //"i_kpkhid": this.i_isagent==1?this.xsComId:this.i_kpkhid , //销售方，代开时为销售方，非代开时为开票方
                    //"vc_kpkhname":this.i_isagent==1?this.xsComname:this.vc_kpkhname ,//开票方
                    "vc_khcreditcode":this.formData.vc_khcreditcode, //开票方识别号
                    "vc_gscreditcode":this.formData.vc_gscreditcode, //开票方识别号
                    "dt_fptime":this.formData.dt_fptime, //开票日期
                    "i_gsid":this.formData.i_gsid,
                    "vc_gsname": this.formData.vc_gsname,
                    //"i_isagent":this.i_isagent, //是否代开，1是0否
                    //'i_dkable':this.isdk,
                    //"i_dlkhid": this.i_isagent==1?this.i_kpkhid:0 ,
                    //"vc_dlkhname":this.i_isagent==1?this.vc_kpkhname:'' , //代理开票方,
                    "f_pay": this.f_pay_upl, //开票金额
                    "f_pay_ws": this.f_pay_ws_upl,
                    "f_pay_zzs": this.f_pay_zzs_upl,
                    'f_gs':this.formData.f_gs,
                    //"vc_note": this.formData.vc_note_upl,
                    "i_isfrom": this.i_isfrom, //来源，0来源于税务云，1来源于员工上传
                    "vc_mainfile_newname":this.vc_mainfile_newname,//发票上传附件的newname
                    //"vc_mainfile_newname":this.vc_newname,
                    'details':this.tableData,
                    //"delIds":this.delIds,
                    //'vc_fkey':this.i_isfrom==1?this.vc_fkey:"",
                    //'vc_no':this.orderWs,
                    'i_gid':sessionStorage.getItem("i_gid"),
                    //'i_bzid_yb':this.i_bzid_yb,
                    'i_invoiceType':this.invoiceType,
                    'vc_relateinvoice_code':this.invoiceType=='2'?this.copyfpcode:null,
                    'i_glfpid':this.invoiceType=='2'?this.i_glfpid:null,
                    'inputOrOutput':"1",//销售
                };
                //console.log(param,'param')
                //return;
                let res=await API.saveToPool(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading_upl=false;
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.loading_upl=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading_upl=false;
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('close')
            },

            async submitUpload() {
                this.loading_upl=true;
                var param = {
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                };
                for (let i = 0; i < this.fileList.length; i++) {
                    //param.append("file", this.fileList[i]);
                    param['flie'+[i]]=this.fileList[i]
                }
                //console.log(param,'param')
                let res = await API.uploadInvoice(param);
                if (res.code == 1) {
                    this.files=res.data.fileList;
                    this.loading_upl=false;
                    this.$forceUpdate()
                    if(res.data.apicode==1){
                        let invoice = res.data.invoice;
                        let details = invoice.details;
                        this.i_isfrom=1;
                        this.formData=invoice;
                        this.tableData=details;
                        this.totalPrice=invoice.f_pay;
                        this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
                        this.vc_mainfile_newname= invoice.vc_mainfile_newname;
                        this.f_pay_ws_upl = invoice.f_pay_ws;
                        this.f_pay_zzs_upl = invoice.f_pay_zzs;
                        this.f_pay_upl = invoice.f_pay;
                        return;
                        this.details_upl = invoice.details;
                        let detailsL = invoice.details.length;
                        this.vc_fpcode_upl = invoice.vc_fpcode;
                        this.vc_pz_upl = detailsL==0?'':(detailsL==1?details[0].vc_fppzname:details[0].vc_fppzname+'等');
                        this.vc_note_upl = invoice.vc_note;
                        this.f_gs_upl = invoice.f_gs;
                        this.dt_fptime = invoice.dt_fptime;

                    }else{
                        this.i_isfrom=0;
                        this.tableData=[];
                        this.totalPrice=0;
                        this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
                        let string='';
                        string=res.data.fileList.map(item=>item.vc_path).join(';')
                        //console.log(string,'string')
                        this.vc_mainfile_newname=string;
                    }
                } else if (res.code == -2) {
                    this.loading_upl=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading_upl=false;
                    this.$message.error(res.message);
                }

            },
            beupload(obj){
                this.fileList.push(obj.file)
                //console.log(this.fileList, 'this.fileList');
            },
            handleRemove(obj, fileList) {
                this.fileList=fileList;
                //console.log(this.fileList, 'this.fileList');
                if(this.fileList.length==0){
                    this.formData={};
                    this.tableData=[];
                    this.totalPrice=0;
                    this.DtotalPrice=this.convertToChineseCapital(this.totalPrice);
                    this.f_pay_ws_upl='';
                    this.f_pay_zzs_upl='';
                    this.f_pay_upl='';
                    return;
                    this.vc_newname='';
                    this.vc_fpcode_upl='';
                    this.vc_pz_upl='';
                    this.vc_note_upl='';
                    this.f_gs_upl='';
                }
            },
            handlePreview(file) {
                //console.log(file,'file---');
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },

            async withInvoiceServer(){
                let param={
                    serviceType:2,
                    detailParam:{
                        recordId:this.formData.recordId
                    }
                };
                let res=await API.withInvoiceServer(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.productList;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            changeData(e,type){
                //console.log(e,type);
                if(type=='bz'){
                    this.i_bzid=e;
                    let choo = this.bzData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_bzname=choo[0].vc_name;
                        this.f_rate=choo[0].f_rate;
                    }else{
                        this.vc_bzname='';
                        this.f_rate=0;
                    }
                }
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.i_origin_khtype = choo[0].i_origin_khtype;
                        this.vc_fymx = choo[0].vc_fymx;
                        //this.i_isagent=choo[0].i_isagent;
                        this.isdk=choo[0].i_dkable;
                        this.i_issd=choo[0].i_issd;
                        this.i_flag=choo[0].i_flag;
                        this.f_sl=choo[0].f_sl;
                        this.i_fytype=choo[0].i_fytype;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.i_isagent=0;
                        this.getkhlist();
                        if(this.i_issd==1){
                            let choo = this.fplxData.filter(item=>{
                                return item.i_id == '1112'
                            });
                            this.i_fptype=choo[0].i_id;
                            this.vc_fptype=choo[0].vc_name;
                        }else{
                            let choo = this.fplxData.filter(item=>{
                                return item.i_id == '0'
                            });
                            this.i_fptype=choo[0].i_id;
                            this.vc_fptype=choo[0].vc_name;
                        }
                        /*if(this.i_flag==1&&this.i_isfrom==0){
                            this.getbzlist();
                        }*/
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.i_origin_khtype=0;
                        this.vc_fymx='';
                        //this.i_isagent=0;
                        this.isdk=0;
                        this.i_issd=0;
                        this.i_flag=0;
                        this.f_sl=0;
                        this.i_fytype=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.i_isagent=0;
                    }

                }
                if(type=='state'){
                    this.isover=e;
                    let choo = this.stateData.filter(item=>{
                        return item.isover == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_isover=choo[0].vc_name;
                    }else{
                        this.vc_isover='';
                    }
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error('请先选择发票类型！');
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                            this.vc_khcreditcode=choo[0].vc_creditcode;
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }else{
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isagent==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        //this.beforehandle();
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                        this.vc_gscreditcode=choo[0].vc_creditcode;
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }else{
                        this.companyName='';
                        this.vc_gscreditcode='';
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isagent==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        //this.beforehandle();
                    }
                }
                if(type=='xs'){
                    this.xsComId=e;
                    let choo = this.xsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.xsComname=choo[0].vc_name;
                        this.vc_khcreditcode=choo[0].vc_creditcode;
                    }else{
                        this.xsComname='';
                        this.vc_khcreditcode='';
                    }
                }
                if(type=='fplx'){
                    this.formData.i_fptype=e;
                    let choo = this.fplxData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.formData.vc_fptype=choo[0].vc_name;
                    }else{
                        this.formData.vc_fptype='';
                    }
                }
                if(type=='code'){
                    this.vc_fkey = e;
                    if(this.vc_fkey!=0){
                        this.beforedetail()
                    }

                }


            },

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
            // 小写金额转化为大写金额
            convertToChineseCapital(val){
                let cnNums = ['零','壹','贰','叁','肆','伍','陆','柒','捌','玖'] //汉字数字
                let cnIntRadice = ['','拾','佰','仟']  //基本单位
                let cnIntUnits = ['元','万','亿','兆'] //整数部分扩展单位
                let cnDecUnits = ['角','分','毫','厘'] //小数部分扩展单位
                // let cnInteger = '整'
                let cnIntLast = '元'
                let integerNum  //金额的整数部分
                let decimalNum  //金额的小数部分
                let chineseStr = '' //输出的中文金额字符串
                let parts; //分离金额后用的数组
                if(val== ''){
                    return ''
                }
                if(val == 0){
                    // return cnNums[0] + cnIntLast + cnInteger
                    return cnNums[0] + cnIntLast
                }
                // 转化为字符串
                val = val + ''
                if(val.indexOf('.') == -1){
                    integerNum = val
                    decimalNum = ''
                }else{
                    parts = val.split('.')
                    integerNum = parts[0]
                    decimalNum = parts[1].substr(0,4)
                }
                // 获取整形部分转化
                if(parseInt(integerNum,10)>0){
                    let zeroCount = 0
                    let IntLen = integerNum.length
                    for(let i=0;i<IntLen;i++){
                        let n = integerNum.substr(i,1)
                        let p = IntLen - i - 1
                        let q = p / 4
                        let m = p % 4
                        if(n == 0){
                            zeroCount ++
                        }else{
                            if(zeroCount > 0){
                                chineseStr += cnNums[0]
                            }
                            // 归0
                            zeroCount = 0
                            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
                        }
                        if(m==0 && zeroCount<4){
                            chineseStr += cnIntUnits[q]
                        }

                    }
                    // chineseStr += cnIntLast
                }
                // 小数部分
                if(decimalNum != ''){
                    let decLen = decimalNum.length
                    for(let i=0;i<decLen;i++){
                        let n = decimalNum.substr(i,1)
                        if(n != 0){
                            chineseStr+=cnNums[Number(n)]+cnDecUnits[i]
                        }
                    }
                }
                if(chineseStr == ''){
                    // chineseStr += cnNums[0]+ cnIntLast + cnInteger
                    chineseStr += cnNums[0]+ cnIntLast
                }else if(decimalNum == ''){
                    // chineseStr += cnInteger
                    chineseStr += ''
                }
                return chineseStr
            },
        },
    }
</script>

<style lang="scss" scoped>
    .padT6{
        padding-top: 6px;
    }
    .padB6{
        padding-bottom: 6px;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-between;

    }
</style>